export const apiConstants = {

    USER_LOGIN: 'weblogin',

    USER_REGISTRATER: 'userRegister',
    PHONE_OTP_VERIFICATION: 'verifyPhoneRegistrationOtp',
    GENRATE_PHONE_VERIFICATION_OTP: 'generatePhoneRegistrationOtp',
    FORGOT_PASSWORD: 'forgotPassword',
    RESET_PASSWORD: 'resetPassword',
    EMAIL_OTP_VERIFICATION: 'generateEmailRegistrationOtp',
    GENRATE_Email_VERIFICATION_OTP: 'verifyEmailRegistrationOtp',
    GET_BUSINESS_EXPIRY: "businessExpiryList",
    // EndPoints for Notification-------------
    GET_NOTIFICATION_BY_USER: 'getNotificationByUser',
    GET_NOTIFICATION_COUNT_BY_ID: 'getNotificationCountByUserId',
    UPDATE_NOTIFICATION: 'updateNotificationByUserId',
    GET_LEADERTREE: '/v3/getTreeDataById',
    GET_LEADERCHILDTREENODE: '/v3/getTreeChildDataById',
    GET_KEY_PARAMS: '/getKeyParams',
    GET_MIGRATION_HISTORY: '/v3/migrationListById',
    GET_MIGRATION_DATA: '/v3/getMigrationInfo',
    GET_TRANSFER_DATA:'v3/transferCreditInfo',
    SEND_TRANSFER_DATA:'v3/verifyCreditTransfer',
    GET_TRANSFER_HISTORY:'v3/transferCreditHistory',
    GET_USER_DATA: '/userprofile'

}